import { useMemo } from 'react'
import {
  PiArrowBendUpLeft,
  PiArrowBendDoubleUpLeft,
  PiArrowBendUpRight,
  PiBell,
  PiChartLineUp,
  PiTrash,
} from 'react-icons/pi'
import { ComposeMode } from './ComposePanel'

export interface EmailAction {
  label: string
  icon: React.ComponentType<{ className?: string; size?: number }>
  onClick: () => void
  disabled: boolean
  hasSeparatorAfter?: boolean
}

/** Create thread-level actions, disabling compose actions when no handler is provided. */
function createEmailThreadActions(
  onCompose?: (mode: ComposeMode) => void
): EmailAction[] {
  const composeDisabled = !onCompose
  return [
    {
      label: 'Reply',
      icon: PiArrowBendUpLeft,
      onClick: () => onCompose?.('reply'),
      disabled: composeDisabled,
    },
    {
      label: 'Reply All',
      icon: PiArrowBendDoubleUpLeft,
      onClick: () => onCompose?.('reply_all'),
      disabled: composeDisabled,
    },
    {
      label: 'Forward',
      icon: PiArrowBendUpRight,
      onClick: () => onCompose?.('forward'),
      disabled: composeDisabled,
      hasSeparatorAfter: true,
    },
    {
      label: 'Schedule a reminder',
      icon: PiBell,
      onClick: () => {},
      disabled: true,
    },
    {
      label: 'Update sales stage',
      icon: PiChartLineUp,
      onClick: () => {},
      disabled: true,
    },
    {
      label: 'Remove from deal',
      icon: PiTrash,
      onClick: () => {},
      disabled: true,
    },
  ]
}

/** Memoized email thread actions — returns live actions when onCompose is provided, disabled actions otherwise. */
export function useEmailThreadActions(
  onCompose?: (mode: ComposeMode) => void
): EmailAction[] {
  return useMemo(() => createEmailThreadActions(onCompose), [onCompose])
}
